<script>
	import ConfirmModal from './ConfirmModal.svelte';
</script>

<ConfirmModal {...$$restProps} confirmLabel="Close" cancelLabel="">
	<slot />
</ConfirmModal>
